import React from 'react';
import PropTypes from 'prop-types';
import { Item } from 'react-stately';

import MathContent from '../../../../math-content';
import ValidatedTextarea from '../../../../textarea/components/validated';
import Picker from '../../../../input-controls/picker';

const FillChoicheSelect = ({ badgeIndex, isValidated, items, onSelectionChange, selectedKey, validationType, value, ...props }) => {
    return isValidated ? (
        <ValidatedTextarea badgeIndex={badgeIndex} type={validationType} value={value} parse={false} />
    ) : (
        <Picker label="label" items={items} onSelectionChange={onSelectionChange} selectedKey={selectedKey} {...props}>
            {(item) => (
                <Item textValue={item.text}>
                    <MathContent>{item.text}</MathContent>
                </Item>
            )}
        </Picker>
    );
};

FillChoicheSelect.propTypes = {
    badgeIndex: PropTypes.string,
    isValidated: PropTypes.bool,
    items: PropTypes.array,
    onSelectionChange: PropTypes.func,
    selectedKey: PropTypes.number,
    validationType: PropTypes.oneOf(['error', 'success', 'warning', 'missing']),
    value: PropTypes.string,
};

export default FillChoicheSelect;
